import { encodeText } from '@aytm/app/stats/lib/util/helpers'

// The words arrive here already decoded -- the cloud draws them as plain text -- while a table
// title is rendered as markup, so it has to be encoded back or the entities decode a second time.
export const renderWCTableProps = (words, mergeWords) => {
  return {
    cols: [
      {
        type: 'title',
        title: 'Most popular words'
      },
      {
        type: 'value',
        title: 'Frequency'
        // format: value => formatAmounts(value)
      }
    ],
    rows: words.slice(0, 15).map((word, i) => {
      return {
        cells: [
          { title: encodeText(word.text, false) },
          { value: !mergeWords && 0 < word.f ? word.f : mergeWords && 0 < word.times ? word.times : '' }
        ],
        position: i + 1
      }
    })
  }
}
